export const IconApply20: {
  name: 'icon_apply_20-0eb6308a4db4'
} = {
  name: 'icon_apply_20-0eb6308a4db4'
}
